import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../../common/containers/icon';
import SearchInput from '../../common/search/searchInput';
const FillFromPreviousButtonHeader = _ref => {
  let jobIndexQuery = _ref.jobIndexQuery,
    jobServerFilter = _ref.jobServerFilter,
    _ref$selectedJob = _ref.selectedJob,
    selectedJob = _ref$selectedJob === void 0 ? '' : _ref$selectedJob,
    _ref$selectedSource = _ref.selectedSource,
    selectedSource = _ref$selectedSource === void 0 ? '' : _ref$selectedSource,
    setSelectedJob = _ref.setSelectedJob,
    setSelectedSource = _ref.setSelectedSource,
    _ref$sources = _ref.sources,
    sources = _ref$sources === void 0 ? [] : _ref$sources,
    _ref$showBack = _ref.showBack,
    showBack = _ref$showBack === void 0 ? true : _ref$showBack;
  const filters = jobIndexQuery.filters;
  const handleSearch = value => {
    jobServerFilter(_objectSpread(_objectSpread({}, filters), {}, {
      text: value
    }), jobIndexQuery);
  };
  const clearSearch = () => {
    handleSearch(null);
  };
  let result = '';
  if (!showBack) {
    result = /*#__PURE__*/React.createElement("div", {
      style: {
        outline: 'none',
        textAlign: 'left'
      }
    }, "Select a Report");
  } else if (!selectedJob) {
    result = /*#__PURE__*/React.createElement("div", {
      style: {
        outline: 'none',
        textAlign: 'left'
      }
    }, "Select a Job", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(SearchInput, {
      size: "sm",
      onChange: handleSearch,
      text: filters && filters.text || null,
      onClear: clearSearch
    }));
  } else if (sources && sources.length && !selectedSource) {
    result = /*#__PURE__*/React.createElement("div", {
      className: "fade-in t-ffpb-back",
      onClick: () => setSelectedJob(null),
      onKeyPress: () => setSelectedJob(null),
      role: "link",
      tabIndex: 0,
      style: {
        outline: 'none',
        cursor: 'pointer',
        textAlign: 'left'
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "angle-left"
    }), " Back");
  } else if (selectedSource) {
    result = /*#__PURE__*/React.createElement("div", {
      className: "fade-in t-ffpb-back",
      onClick: () => setSelectedSource(null),
      onKeyPress: () => setSelectedSource(null),
      role: "link",
      tabIndex: 0,
      style: {
        outline: 'none',
        cursor: 'pointer',
        textAlign: 'left'
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "angle-left"
    }), " Back");
  } else if (selectedJob) {
    result = /*#__PURE__*/React.createElement("div", {
      className: "fade-in t-ffpb-back",
      onClick: () => setSelectedJob(null),
      onKeyPress: () => setSelectedJob(null),
      role: "link",
      tabIndex: 0,
      style: {
        outline: 'none',
        cursor: 'pointer',
        textAlign: 'left'
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "angle-left"
    }), " Back");
  }
  return result;
};
FillFromPreviousButtonHeader.propTypes = {
  jobIndexQuery: PropTypes.shape({}).isRequired,
  jobServerFilter: PropTypes.func.isRequired,
  selectedJob: PropTypes.string,
  selectedSource: PropTypes.shape({}),
  setSelectedJob: PropTypes.func.isRequired,
  setSelectedSource: PropTypes.func.isRequired,
  sources: PropTypes.arrayOf(PropTypes.shape({})),
  showBack: PropTypes.bool
};
export default FillFromPreviousButtonHeader;